import { Payment } from '@repo-level/core-front';
import { getCurrencyName, mapCurrencySymbol } from 'helpers/currency';
import { brandSizeMap, getBrandKey } from 'modules/payments';
import { useMemo } from 'react';

interface PaymentMethodCardProps {
  method: Payment.Method;
  index: number;
  onSelect: (method: Payment.Method) => void;
  currentMethod?: Payment.Method;
}

export const PaymentMethodCard = ({
  method,
  index,
  onSelect,
  currentMethod,
}: PaymentMethodCardProps) => {
  const {
    iconSrc,
    termsOfService: { restrictions },
    translationKey,
    id,
  } = method;

  const { minAmountValue, amountCurrencyCode, originCryptoCurrency } =
    restrictions || {};

  const { width: widthSizesImages, height: heightSizesImages } = useMemo(() => {
    const key = getBrandKey(id);
    return brandSizeMap[key];
  }, [id]);

  return (
    <div key={`${id}_${index}`} className="button-wrapper">
      <button
        onClick={() => onSelect(method)}
        className={id === currentMethod?.id ? 'active' : ''}
      >
        {iconSrc && (
          <img
            src={iconSrc}
            alt={`${translationKey} logo`}
            width={widthSizesImages}
            height={heightSizesImages}
          />
        )}
      </button>

      <div className="limits-wrapper">
        {minAmountValue && (
          <div className="limits">
            <span className="limits-amount">min</span>
            {originCryptoCurrency ? (
              <>
                <span className="limits-amount">{minAmountValue}</span>
                <span className="limits-amount">
                  {getCurrencyName(
                    mapCurrencySymbol[amountCurrencyCode].symbol
                  )}
                </span>
              </>
            ) : (
              <div>
                <span className="limits-amount">
                  {getCurrencyName(
                    mapCurrencySymbol[amountCurrencyCode].symbol
                  )}
                </span>
                <span className="limits-amount">{minAmountValue}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
